/* istanbul ignore file  */
import axios from "axios";
import { getCookie } from "../commonUtils";

const instance = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  headers: {
    "content-type": "application/json",
    Authorization: getCookie('authToken'),
  },
});

instance.interceptors.request.use((request) => {
  request.params = request.params || {};
  return request;
});

instance.interceptors.response.use((response) => {
  return {
    data: response.data,
    status: response.status,
    statusText: response.statusText,
  };
});

export default instance;
